import ConnectionStatus from "components/ConnectionStatus";
import React from "react";
import { Link } from "react-router-dom";
import { useWebSocket } from "WebSocketContext";
import { useGameContext } from "GameContext";

import BackButton from "components/BackButton";
import BasicButton from "components/General/BasicButton";
import IntroModal from "components/Host/IntroModal";
import DraggableDivider from "components/General/DraggableDivider";

import GameSettings from "components/Host/GameSettings";
import PlayersMenu from "components/Player/PlayersMenu";
import JoinAsPlayerModal from "components/Host/JoinAsPlayerModal";
import { useNavigate } from "react-router-dom";

import { useMemo, useCallback, useEffect, useState } from "react";

const CreateGame: React.FC = () => {
  const { isConnected, playerId, socket } = useWebSocket();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Are you sure you want to leave? Data may be lost";
      if (!window.confirm(message)) {
        // User pressed "Cancel" → block unload
        event.preventDefault();
        event.returnValue = "";
      }
      // If user pressed "OK", allow unload
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const {
    connectedIds,
    gameId,
    gameTimer,

    hostIsPlaying,
    players,
  } = useGameContext() as any;

  const allPlayersReady = useMemo(() => {
    for (let i=0; i < players.length; i++) {
      const ply = players[i]

      if (!ply.role || !ply.estate) {
        return false
      }
    }
    return true
  }, [players])

  const [showIntroModal, setShowIntroModal] = useState(true);
  const [showJoinModal, setJoinModal] = useState(false);
  const navigate = useNavigate()

  const onMessage = useCallback((event: MessageEvent<string>) => {
    if (event.data) {
      const message = JSON.parse(event.data);
      if (message.kind === "StartingGame") {
        if (hostIsPlaying) {
          navigate("/play/main");
        } else {
          navigate("/play/main/host");
        }
      }
    }
  }, [hostIsPlaying])


  useEffect(() => {
    if (!socket) return;
    socket.addEventListener("message", onMessage);

    return () => {
      if (socket) {
        socket.removeEventListener("message", onMessage);
      }
    }
  }, [socket, hostIsPlaying]);

  function joinGame(estate:string, role:string) {
    if (!socket) {
      return;
    }

    const mes = JSON.stringify({
      kind: "JoinedGame",
      toIds: connectedIds,
      playerId: playerId,

    })
    socket?.send( mes );

    const mess = JSON.stringify({
      kind: "UpdatePlayerInfo",
      toIds: connectedIds,
      playerId: playerId,
      newData: {
        playerName: "HOST",
        estate: estate,
        role: role,
      },
    })

    socket?.send( mess );
  }

  function startGame() {
    if (players.length === 0) {
      alert("No players in game");
      return
    }

    if (!allPlayersReady) {
      alert("All players must choose a role");
      return
    }

    if (!socket) {
      return;
    }

    const mes = JSON.stringify({
      kind: "StartGame",
      gameId: gameId,
      initialGameTime: gameTimer,
    })

    socket?.send( mes );
  }

  return (
    <div className="flex h-[100vh] w-full">
      <DraggableDivider
        defaultRatio={0.2}
        orientation={"horizontal"}
        topHalf={
          <div className="w-full h-full flex flex-col overflow-y-auto">
            <GameSettings />

            <div className="flex flex-row p-2 gap-2">
              <BackButton useAbsolute={false}/>
              <BasicButton text="Help" onClick={() => setShowIntroModal(true)}/>
            </div>
          </div>
        }
        bottomHalf={
          <div className="flex flex-col p-2 h-full">
            <PlayersMenu />

            <div className="flex flex-row justify-between mb-12">
              <BasicButton text="Join as player" onClick={() => {
                if (hostIsPlaying) {
                  alert("Host is already playing");
                  return
                }
                setJoinModal(true)
              }} />
              <BasicButton text="Start" onClick={startGame} />
            </div>
          </div>
        }
      />

      <ConnectionStatus />
      <IntroModal
        open={showIntroModal}
        setOpen={setShowIntroModal}
      />

      <JoinAsPlayerModal
        open={showJoinModal}
        setOpen={setJoinModal}
        joinGame={joinGame}
      />
    </div>
  );
};

export default CreateGame;
